// Vendor-agnostic analytics helper.
// Forwards events to any of these if present on window:
// - Google Analytics (gtag)
// - Google Tag Manager (dataLayer)
// - Plausible
// - PostHog
// Also logs to console in dev so you can verify wiring without a provider.

type EventProps = Record<string, string | number | boolean | null | undefined>;

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
    plausible?: (event: string, options?: { props?: EventProps }) => void;
    posthog?: { capture: (event: string, props?: EventProps) => void };
  }
}

export function trackEvent(event: string, props: EventProps = {}) {
  if (typeof window === "undefined") return;

  try {
    window.gtag?.("event", event, props);
    window.dataLayer?.push({ event, ...props });
    window.plausible?.(event, { props });
    window.posthog?.capture(event, props);
  } catch (err) {
    // Never let analytics break the UI.
    console.warn("[analytics] failed", err);
  }

  if (import.meta.env.DEV) {
    console.info("[analytics]", event, props);
  }
}